import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";
import type { PaginationAndOrderParams } from "@src/shared/types/pagination.types";

export interface GetTransactionsParams
  extends Partial<
    Omit<PaginationAndOrderParams, "page" | "pageSize" | "orderDirection">
  > {
  page?: number | string;
  pageSize?: number | string;
  search?: string;
  userId?: string | number;
  paymentMethod?: string;
  transactionType?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
}

export interface TransactionTimelineRecord {
  event?: string;
  notes?: string | null;
  performedBy?: number | null;
  performedByType?: string | null;
  createdAt?: string;
}

export interface TransactionLineItemRecord {
  id?: number | string;
  name?: string | null;
  productName?: string | null;
  description?: string | null;
  quantity?: number;
  unitPrice?: number;
  price?: number;
  taxAmount?: number;
  discountAmount?: number;
  taxRate?: number;
  couponDiscountAmount?: number;
  shippingCost?: number;
  discountId?: number | null;
  couponId?: number | null;
  date?: string | null;
  time?: string | null;
  total?: number;
  totalAmount?: number;
  itemType?: string;
  itemId?: number | string;
  businessId?: number;
  businessName?: string | null;
  imageUrl?: string | null;
  category?: string | null;
  timeline?: TransactionTimelineRecord[];
}

export interface TransactionRecord {
  id?: number | string;
  transactionType?: string | null;
  type?: string | null;
  userName?: string | null;
  userEmail?: string | null;
  businessName?: string | null;
  businessNames?: string[];
  paymentMethod?: string | null;
  status?: string | null;
  subtotal?: number;
  amount?: number;
  tax?: number;
  taxAmount?: number;
  discount?: number;
  discountAmount?: number;
  total?: number;
  finalAmount?: number;
  currency?: string | null;
  lineItems?: TransactionLineItemRecord[];
  timeline?: TransactionTimelineRecord[];
  createdAt?: string;
  updatedAt?: string;
}

export class TransactionService {
  async getTransactions(query: GetTransactionsParams) {
    return apiService.get("/transactions", {
      params: sanitizeQueryParams(query),
    });
  }

  async getTransaction(id: string) {
    return apiService.get(`/transactions/${id}`);
  }
}

export const transactionService = new TransactionService();
